<template>
  <div class="v-breadcrumb">
    <BContainer>
      <nav class="v-breadcrumb-nav" aria-label="breadcrumb">
        <ol class="v-breadcrumb-nav-items">
          <li
            class="v-breadcrumb-nav-item"
            v-for="item in items"
            :key="item.text"
          >
            <router-link v-if="item.link" :to="item.link">
              {{ item.text }}
            </router-link>
            <span v-else>
              {{ item.text }}
            </span>
          </li>
        </ol>
      </nav>
    </BContainer>
  </div>
</template>

<script>
export default {
  name: "BaseBreadcrumb",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    backgroundColor: {
      type: String,
      default: "#ffffff"
    }
  }
};
</script>
